/**
 * "New project…" in the toolbar switcher opens the Projects view's own create
 * dialog (one dialog, not a second one). The switcher records the request and
 * navigates; ProjectsTab takes it once on mount or when it changes.
 */
import { create } from 'zustand';

export const useProjectCreateRequest = create(() => ({ nonce: 0, handled: 0 }));

export const requestProjectCreate = () => useProjectCreateRequest.setState((s) => ({ nonce: s.nonce + 1 }));

/** True once per request: marks it handled, so a remount does not reopen the dialog. */
export function takeProjectCreate() {
  const { nonce, handled } = useProjectCreateRequest.getState();
  if (nonce <= handled) return false;
  useProjectCreateRequest.setState({ handled: nonce });
  return true;
}
